import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClipboardCheck, faRectangleAd} from "@fortawesome/free-solid-svg-icons";
import FilterButton from "../FilterButton.jsx";
import useUserSettings from "../../utils/useUserSettings.js";
import LoadingComponent from "../LoadingComponent.jsx";

export default function MarketingAndManagerSwitch() {
    let {t} = useTranslation();

    let [userSettings, setUserSettings] = useUserSettings();

    let loadingClassName = useMemo(
        () => (userSettings === null ? 'w-4 -mt-4' : ''),
        [userSettings],
    );

    return (<FilterButton
        button={
            <LoadingComponent
                className={'flex justify-center items-center gap-2 text-nowrap ' + loadingClassName}
                loading={!userSettings}
                spinnerType={'spinner-small'}
            >
                {userSettings && <>
                    <FontAwesomeIcon
                        icon={userSettings?.isMarketing ? faRectangleAd : faClipboardCheck}
                        className={'pr-2'}
                    />
                    {userSettings?.isMarketing ? t('filter.marketing') : t('filter.management')}
                </>}
            </LoadingComponent>


            /* <div className={'flex justify-center items-center gap-2'}>


             </div>*/}
        onClick={() => {
            setUserSettings({...userSettings, isMarketing: !userSettings?.isMarketing});
        }}
    />);
}
